import React, {useEffect, useState} from 'react'
import {Alert} from 'react-bootstrap'

interface InitialSyncAlertProps {
  initialPlatformSyncMessage: string
}

const InitialSyncAlert: React.FC<InitialSyncAlertProps> = ({initialPlatformSyncMessage}) => {
  const [isUserAdmin, setIsUserAdmin] = useState(false)
  const [screenWidth, setScreenWidth] = useState(window.innerWidth)

  useEffect(() => {
    if (localStorage.getItem('loggedInAdminAccessToken')) {
      setIsUserAdmin(true)
    }

    const handleResize = () => {
      setScreenWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  // Responsive styles
  const getAlertStyles = () => {
    if (screenWidth <= 767) {
      return {
        margin: 'auto',
        maxWidth: '98%',
        fontSize: '10px'
      }
    } else if (screenWidth <= 1024) {
      return {
        margin: 'auto',
        maxWidth: '94%',
        fontSize: '12px'
      }
    } else {
      return {
        margin: 'auto',
        fontSize: '13px',
        maxWidth: '94%'
      }
    }
  }

  const {margin, fontSize, maxWidth} = getAlertStyles()

  return (
    <>
      <Alert
        variant='warning'
        className='d-flex p-2 mt-1'
        style={{margin, maxWidth}}
      >
        <span className='indicator-progress' style={{display: 'block'}}>
          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
        </span>
        <div className='ms-2 text-center' style={{fontSize}} dangerouslySetInnerHTML={{ __html: initialPlatformSyncMessage }}> 
        </div>
      </Alert>
    </>
  )
}

export default InitialSyncAlert
